import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { map } from "lit/directives/map.js";
import "./learningcenterfilter";
import "../paging/paging";

export type TFilterItem = {
  key: number;
  value: string;
  checked: boolean;
  group: string;
};
export enum FilterTypes {
  CATEGORIES = "categories",
  PRODUCTS = "products",
  SECTORS = "sectors",
  SUBJECTS = "subjects",
}
@customElement("learningcenter-filters")
export class LearningCenterFilters extends LitElement {
  @property()
  accessor dictionary: any = {};

  @property()
  accessor culture: string = "";

  createRenderRoot() {
    return this;
  }

  baseApiUrl = "/api/LearningCenter/";
  items: TFilterItem[] = []; // Changed from Set to Array
  includeCategories: Number[] = [];
  includeTags: Number[] = [];

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.fetchAllItems();
  }

  fetchAllItems() {
    const urlParams = new URLSearchParams(window.location.search);
    this.includeCategories = urlParams.getAll("category").map(Number) || [];
    this.includeTags = urlParams.getAll("tag").map(Number) || [];
    this.items = [];
    this.fetchItems(FilterTypes.CATEGORIES);
    this.fetchItems(FilterTypes.SUBJECTS);
    this.fetchItems(FilterTypes.PRODUCTS);
    this.fetchItems(FilterTypes.SECTORS);
  }

  async fetchItems(apiEndpoint: string) {
    try {
      const response = await fetch(this.baseApiUrl + apiEndpoint+`?cultureName=${this.culture}`);
      const data = await response.json();
      data.forEach((item: TFilterItem) => {
        this.items.push({
          key: item.key,
          checked:
            this.includeCategories.includes(item.key) ||
            this.includeTags.includes(item.key),
          value: item.value,
          group: apiEndpoint,
        });
      });

      this.requestUpdate();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  clearFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    this.includeCategories = [];
    this.includeTags = [];
    urlParams.delete("category");
    urlParams.delete("tag");

    /* if we dont want to reload the page  */
    // window.history.replaceState(
    //   {},
    //   "",
    //   `${window.location.pathname}?${urlParams}`
    // );

    window.location.href = `${window.location.pathname}?${urlParams}`;
    this.fetchAllItems();
  }
  removeFilter(filter: TFilterItem) {
    const urlParams = new URLSearchParams(window.location.search);
    if (filter.group === FilterTypes.CATEGORIES) {
      this.includeCategories = this.includeCategories.filter(
        (item) => item !== filter.key
      );
      urlParams.delete("category");
      this.includeCategories.forEach((category) => {
        urlParams.append("category", category.toString());
      });
    } else {
      this.includeTags = this.includeTags.filter((item) => item !== filter.key);
      urlParams.delete("tag");
      this.includeTags.forEach((tag) => {
        urlParams.append("tag", tag.toString());
      });
    }

    /* if we dont want to reload the page  */
    // window.history.replaceState(
    //   {},
    //   "",
    //   `${window.location.pathname}?${urlParams}`
    // );

    window.location.href = `${window.location.pathname}?${urlParams}`;
    this.fetchAllItems();
  }
  renderActiveFilterButton(filter: TFilterItem) {
    return html`
      <button
        type="button"
        class="button button-filter"
        @click="${() => this.removeFilter(filter)}"
      >
        ${filter.value}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="11"
          viewBox="0 0 13 11"
          fill="none"
        >
          <path
            d="M1.79421 10.8334H0L4.62253 6.15477L5.33337 5.5L4.62253 4.84523L0 0.166626L1.79421 0.166626L7.07374 5.5L1.79421 10.8334Z"
            fill="currentColor"
          />
          <path
            d="M10.7531 10.8334H12.5474L7.92483 6.15477L7.21399 5.5L7.92483 4.84523L12.5474 0.166626L10.7531 0.166626L5.47363 5.5L10.7531 10.8334Z"
            fill="currentColor"
          />
        </svg>
      </button>
    `;
  }
  renderActiveFilters() {
    const activeFilters = this.items.filter((item) => item.checked);
    if (activeFilters.length === 0) {
      return html``;
    }

    return html`
      <div class="flex flex-wrap gap-2">
        ${map(activeFilters, (filter) => this.renderActiveFilterButton(filter))}
        <button
          type="button"
          class="button button-filter button-filter-clear"
          @click="${() => this.clearFilters()}"
        >
          
          ${JSON.parse(this.dictionary)["clearall"] ?? ""}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="11"
            viewBox="0 0 13 11"
            fill="none"
          >
            <path
              d="M1.79421 10.8334H0L4.62253 6.15477L5.33337 5.5L4.62253 4.84523L0 0.166626L1.79421 0.166626L7.07374 5.5L1.79421 10.8334Z"
              fill="currentColor"
            />
            <path
              d="M10.7531 10.8334H12.5474L7.92483 6.15477L7.21399 5.5L7.92483 4.84523L12.5474 0.166626L10.7531 0.166626L5.47363 5.5L10.7531 10.8334Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    `;
  }

  render() {
    return html`
      <div class="flex flex-col gap-4 mt-10">
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 md:gap-4">
          <learningcenter-filter
            .items="${this.items.filter(
              (item) => item.group === FilterTypes.CATEGORIES
            )}"
            filterName="category"
            .title="${JSON.parse(this.dictionary)["category"] ?? ""}"
            .dictionary="${this.dictionary}"
          ></learningcenter-filter>
          <learningcenter-filter
            .items="${this.items.filter(
              (item) => item.group === FilterTypes.SUBJECTS
            )}"
            filterName="tag"
            .title="${JSON.parse(this.dictionary)["subject"] ?? ""}"
            .dictionary="${this.dictionary}"
          ></learningcenter-filter>
          <learningcenter-filter
            .items="${this.items.filter(
              (item) => item.group === FilterTypes.PRODUCTS
            )}"
            filterName="tag"
            .title="${JSON.parse(this.dictionary)["products"] ?? ""}"
            .dictionary="${this.dictionary}"
          ></learningcenter-filter>
          <learningcenter-filter
            .items="${this.items.filter(
              (item) => item.group === FilterTypes.SECTORS
            )}"
            filterName="tag"
            .title="${JSON.parse(this.dictionary)["sector"] ?? ""}"
            .dictionary="${this.dictionary}"
          ></learningcenter-filter>
        </div>
        <div>${this.renderActiveFilters()}</div>
      </div>
    `;
  }
}
